import { useEffect, useState } from "react";
import {
    GetContractorById
} from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi";
import routes from '../../../../../Routes/routes';
import {useLocation, useNavigate} from 'react-router-dom';

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @Job Title: Full Stack Developer
 *
 * @Description:
 * Custom hook for managing and retrieving contractor-related information
 * including employees, documents, vehicles, and work shifts.
 */

export const EmployeeFlowContractorDetailsApp = ({
     dispatch,
     params,
     setElementDetails,
     setWorkShiftsList,
     setCustomizedList,
 }) => {

    const { id } = params;
    const navigate = useNavigate();
    const location = useLocation();
    let { state } = location;
    const [expandedRowId, setExpandedRowId] = useState(null);

    // On mount: fetch contractor details
    useEffect(() => {
        getContractorDetail();
    }, []);


    /**
     * Fetches detailed contractor data by ID.
     * Also retrieves work shifts and customized shifts,
     * and triggers document fetch by user ID.
     */
    const getContractorDetail = () => {
        dispatch(GetContractorById(id)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setElementDetails(data);
                    setWorkShiftsList(data?.workShifts.map((item) => ({ ...item, new: false })));
                    setCustomizedList(data?.customs?.map((item) => ({ ...item, added: true, new: false })));
                }
            }
        );
    };

   const goBack = () => {
       const resolvedCurrentTab = state?.currentTab ?? state?.backUrl?.state?.currentTab ?? 0;
       if (state?.backUrl) {
           if (state.backUrl?.pathname) {
               navigate(state.backUrl.pathname, {
                   state: { ...state.backUrl.state, currentTab: resolvedCurrentTab },
               });
           } else {
               navigate(state.backUrl, {
                   state: { currentTab: resolvedCurrentTab },
               });
           }
       } else {
           navigate(routes.contractor.list, {
               state: { currentTab: resolvedCurrentTab },
           });
       }
   };
   
    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };
    // Return pagination configurations for use in the component
    return {
        goBack,
        handleRowExpand
    };
};
